import { AxiosInstance } from "@bps/http-client";

import {
  OpsReportDefinition,
  OpsReportInstance
} from "./plt-reports-ops-gateway.dtos";
import { IPlatformReportsOpsGateway } from "./plt-reports-ops-gateway.interface";

export class PlatformReportsOpsGateway implements IPlatformReportsOpsGateway {
  constructor(private api: AxiosInstance) {}

  getOpsReportDefinitions = async (): Promise<OpsReportDefinition[]> => {
    const { data } = await this.api.post("reportDefinitions");
    return data;
  };

  getOpsReportInstanceByName = async (
    name: string,
    body: { FieldDeviceId?: string }
  ): Promise<OpsReportInstance> => {
    const { data } = await this.api.post(`reportInstance/name/${name}`, body);
    return data;
  };
}
